export const DASHBOARD = 'dashboard';
export const REPORT = 'reports';
export const ANALYTICS = 'analytics';

export const doubleDash = '--';

export const INSIGHT_PAGES = {
  overview: 'overview',
  sales: 'sales',
  customers: 'customers',
  operations: 'operations',
  tracking: 'tracking',
  products: 'products',
};

export const ANALYTICS_VIEW_TYPE = {
  // non standard or premium sellers who are account owners or trial account with at least 1 label (advanced)
  full: 'full',
  // Free or Starter sellers who are account owners or trial accounts with no labels (starter) - Looker Dashboards are locked
  locked: 'locked',
  // NON account owners and plan (basic) - Looker Dashboards are not displayed in left nav
  partial: 'partial',
};
